module.exports = __webpack_public_path__ + "static/media/web-logo.9d090cf4.svg";